// Ajuste do indicador da Realização Destaque pelo gestor imediato.
//
// Regra de EXCEÇÃO, deliberadamente fora do fluxo de apreciação: o aggregate
// `indicadores_vinculados` anexa `{cod: 1, nome: 'TEMPORÁRIO - AJUSTAR NA VALIDAÇÃO'}`
// à lista de todo cadastrante, e quem não tinha indicador vinculado no ciclo acabou
// cadastrando com esse placeholder. O acerto precisa acontecer DEPOIS, com o ciclo já
// encerrado — por isso nada aqui olha janela de apreciação, etapa, status ou cod_etapa:
// canEvaluate/canEdit são presos às janelas e devolvem false em ciclo fechado.
// Quem enxerga a realização na tela, ajusta.

/**
 * Indicador AINDA no placeholder — único estado que admite ajuste.
 *
 * Exige o `cod 1` positivamente: ausente NÃO conta. Na listagem do gestor o campo pode
 * simplesmente não ter vindo (o `prepare` dos tasks_manager_* recorta o payload da lista),
 * e tratar ausência como pendência acendia o botão em TODA realização. Com o campo
 * carregado a regra é exata; sem ele o botão some — falha para o lado seguro.
 */
function hasPendingIndicator(task: any): boolean {
  const cod = task?.indicator?.cod;

  return cod === 1 || cod === '1';
}

function isOriginalManager(task: any, playerInfo: any): boolean {
  return String(task?.original_manager) === String(playerInfo?._id);
}

/**
 * Par de dupla do gestor imediato — liberado apenas quando a dupla ATUAL do gestor
 * imediato bate com o parceiro REGISTRADO na realização. A interseção é intencional:
 * `non_evaluator` sozinho acumula os parceiros dos níveis seguintes (N2/Pit Stop/N3),
 * e a dupla atual sozinha liberaria um parceiro que não participou daquela realização.
 * Dupla desfeita ou trocada desde então não libera ninguém — o gestor imediato segue
 * podendo ajustar.
 */
function isImmediateManagerPartner(task: any, playerInfo: any): boolean {
  const currentPair = task?.original_manager_detail?.mad_dupla;
  const registeredPartners = task?.non_evaluator;

  if (!Array.isArray(currentPair) || !Array.isArray(registeredPartners)) return false;

  const playerId = String(playerInfo?._id);

  return (
    currentPair.some((pair: any) => pair?._id && String(pair._id) === playerId) &&
    registeredPartners.some((partner: any) => String(partner) === playerId)
  );
}

export function canUpdateIndicator(task: any, playerInfo: any): boolean {
  if (!task || !playerInfo?._id || !hasPendingIndicator(task)) return false;

  return isOriginalManager(task, playerInfo) || isImmediateManagerPartner(task, playerInfo);
}
